import { useEffect, useRef } from 'react';

import Button from '@/componentsv2/Button';

interface CurrentPeriodTriggerProps {
  /** True once the form has been open: the button takes focus back when it returns. */
  focusOnMount: boolean;
  onOpen: () => void;
}

/**
 * The Submit hours button under the current-period row, right-aligned like
 * every row's actions. The form replaces it while open, so the page never holds
 * two Submit hours buttons.
 */
export default function CurrentPeriodTrigger({
  focusOnMount,
  onOpen,
}: CurrentPeriodTriggerProps): JSX.Element {
  const button = useRef<HTMLButtonElement | HTMLAnchorElement>(null);

  useEffect(() => {
    if (focusOnMount) button.current?.focus();
  }, [focusOnMount]);

  return (
    <div className="flex justify-end">
      <Button ref={button} onClick={onOpen}>
        Submit hours
      </Button>
    </div>
  );
}
